module.exports = __webpack_public_path__ + "img/idea.fb724d0c.png";